if (!process.env.CMS_TOKEN) {
  throw new Error('Check your CMS_TOKEN env');
}

export const SITE_URL = 'https://hyerdev.com.br';
export const CMS_URL = 'https://hyerdev.logcms.com.br';

export const CMS_TOKEN = process.env.CMS_TOKEN;
